export const parseJsonResponse = ({ response, onResponse, onError }) => {
  response.json()
    .then((data) => {
      onResponse(data);
    })
    .catch(() => {
      onError({
        feedbackMessage: "Something went wrong. Please try again or contact support at contact@isibute.com.",
        feedbackVariant: "error",
      });
    });
};
